<span class="severity-chip" [ngClass]="[chipClass, compact ? 'compact' : '']" [title]="title">
  <span class="severity-chip-label">{{ label | translate }}</span>
</span>
